import { effect, Injectable, signal } from '@angular/core'

import { PortabilityRequestsBaseService } from './portability-requests-base.service'
import {
  IRequestLine,
  IRequiredFiles,
  TPortabilityRequestFilesConfig,
} from '../../models/portability-request.model'
import { ApiService } from '../api/api.service'

@Injectable({
  providedIn: 'root',
})
export class PortabilityRequestsFilesConfigService {
  readonly FILES_CONFIG_API_ENDPOINT = '/portability-request/files-config'

  filesConfig = signal<TPortabilityRequestFilesConfig | null>(null)
  requiredFileTemplates = signal<IRequiredFiles[]>([])

  constructor(private apiService: ApiService) {
    this.loadFilesConfigFromSession()
  }

  effect = effect(() => {
    const filesConfig = this.filesConfig()

    if (filesConfig) {
      this.requiredFileTemplates.set(this.setRequiredFileTemplates(filesConfig))
    }
  })

  public fetchPortabilityRequestFilesConfig(): void {
    this.apiService
      .get<TPortabilityRequestFilesConfig>(this.FILES_CONFIG_API_ENDPOINT)
      .subscribe({
        next: (filesConfig) => {
          if (filesConfig) {
            this.filesConfig.set(filesConfig)
            sessionStorage.setItem('files-config', JSON.stringify(filesConfig))
          }
        },
      })
  }

  private loadFilesConfigFromSession(): void {
    const storedConfig = sessionStorage.getItem('files-config')

    if (storedConfig) {
      this.requiredFileTemplates.set(
        this.setRequiredFileTemplates(JSON.parse(storedConfig)),
      )
    }
  }

  setRequiredFileTemplates(filesCofig: TPortabilityRequestFilesConfig) {
    return [
      {
        label: 'COMMON.DOCUMENTS.DOCUMENTS_LABEL.MANDATE',
        filename: filesCofig['MANDATE'],
        file: null,
      },
      {
        label: 'COMMON.DOCUMENTS.DOCUMENTS_LABEL.DATA_PROCESSING_MANAGER',
        filename: filesCofig['DATA_PROCESSING_MANAGER'],
        file: null,
      },
      {
        label: 'COMMON.DOCUMENTS.DOCUMENTS_LABEL.SIGNATURE_CERTIFICATE',
        filename: filesCofig['SIGNATURE_CERTIFICATE'],
        file: null,
      },
      {
        label: 'COMMON.DOCUMENTS.DOCUMENTS_LABEL.STORE_APPENDIX',
        filename: filesCofig['STORE_APPENDIX'],
        file: null,
      },
    ]
  }
}
